import type { FaireProductEntity } from "../../entity_types/product";

export const p_4s9d5yvacb: FaireProductEntity = {
  token: "p_4s9d5yvacb",
  type: "product",
  name: "Mammals of Midwest Playing Cards",
  brandName: "AdventureKEEN",
  imageUrl:
    "https://cdn.faire.com/fastly/74ea317325cab51cc42fc4861fee9397212fe463253b0543200b867db285e56b.jpeg",
  priceDollars: 4.48,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/7ce6445b1eafe52cb4c04eb0ed7795237c303d3ac019b8434b0d98325318f9a8.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
